<template>
  <div class="inline-flex items-center gap-1">
    <span>{{ __("Made with", "gaspesia") }}</span>
    <IconLucideHeart class="w-3 h-3" />
    <span>{{ __("by", "gaspesia") }}</span>
    <a href="https://websimple.com" target="_blank" rel="noopener noreferrer"> Websimple </a>
  </div>
</template>
